import { postRequest } from './request';

export const generateJobSpecs = async (id) => {
  const body = { id };

  if (id && window.sessionStorage.shareJobId === id) {
    body.shareKey = window.sessionStorage.shareKey;
  }

  const data = await postRequest({
    url: '/dfd/generate-job-specs',
    body,
  });

  return {
    qualifications: data.qualifications,
    responsibilities: data.responsibilities,
    headers: data.headers,
  };
};

export const generateJobProfile = async (ulid, { useExistingSummary = false } = {}) => {
  const { profile = {} } = (await postRequest({
    url: '/dfd/generate-job-profile',
    body: { ulid, use_existing_summary: useExistingSummary },
  })) || {};
  return { profile };
};

export const generateJobProfileSummary = async (ulid) => {
  const { summary, field_type: fieldType } = await postRequest({
    url: '/dfd/generate-job-profile-summary',
    body: { ulid },
  });
  return { summary, fieldType };
};

export const generateJobProfileSummaryRefine = async (ulid, { operation, baseSummary }) => {
  const { summary, field_type: fieldType } = await postRequest({
    url: '/dfd/generate-job-profile-summary-refine',
    body: { ulid, operation, base_summary: baseSummary },
  });
  return { summary, fieldType };
};

export const generateAiSuggestions = async ({ jobId, ruleId, text }) => {
  const body = { id: jobId, ruleId, highlightedText: text };

  if (jobId && window.sessionStorage.shareJobId === jobId) {
    body.shareKey = window.sessionStorage.shareKey;
  }

  const data = await postRequest({
    url: '/dfd/generate-ai-suggestions',
    body,
  });

  return data;
};
